import { AppContextData } from '@contexts/app/AppContextData';
import { getAppContextFromCronos } from '@contexts/app/builders/getAppContextFromCronos';
import { getAppContextFromSearch } from '@contexts/app/builders/getAppContextFromSearch';
import { getAppPlatform } from '@contexts/app/builders/getAppPlatform';
import { getCookie } from '@utils/getCookie';
import { isInIframe } from '@utils/isInIframe';
import { WindowObj } from '@utils/windowObj';
import { AppSettingContextData } from '@contexts/appSetting/AppSettingContext';

export function buildAppContextData(root: HTMLElement, appSetting: AppSettingContextData): AppContextData {
    const appContextFromCronos = getAppContextFromCronos(root);
    const appContextFromSearch = getAppContextFromSearch();
    const iframeMode = isInIframe();
    const getULApiUrl = (): string => {
        /* istanbul ignore if: we dont test non-prod code */
        if (!__PROD__ && appSetting.tokenGrantType?.parentWhitelistedOrigin) {
            try {
                const urlParams = new URLSearchParams(
                    (iframeMode ? WindowObj.parent.location : WindowObj.location).search
                );
                const ulApiFromSearch = urlParams.get('ul_api');
                if (!!ulApiFromSearch) {
                    document.cookie = 'ul_api=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
                    document.cookie = `ul_api=${ulApiFromSearch};`;
                    return ulApiFromSearch;
                }
            } catch (ex) {}

            const { ul_api: ulApiFromCookie } = getCookie();
            if (!!ulApiFromCookie) {
                return ulApiFromCookie;
            }
        }
        return __ULAPI__ || window.location.origin;
    };

    return {
        iframeMode,
        ...appContextFromCronos,
        ...appContextFromSearch,
        ulApiUrl: getULApiUrl(),
        // TODO: Replace this if we can get from cronos
        appPlatform: getAppPlatform(appContextFromSearch.appId),
    };
}
